import React from "react";

export const UnrepliedIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4765_880)">
      <path
        d="M12 6C13.103 6 14 5.103 14 4C14 2.897 13.103 2 12 2C10.897 2 10 2.897 10 4C10 5.103 10.897 6 12 6ZM12 3C12.5515 3 13 3.4485 13 4C13 4.5515 12.5515 5 12 5C11.4485 5 11 4.5515 11 4C11 3.4485 11.4485 3 12 3ZM13 10.927C13 10.9795 12.939 11.0155 12.885 10.989L10.6515 9.4995H6V3.5C6 3.2245 6.2245 3 6.5 3H9.1745C9.3065 2.627 9.5095 2.2885 9.7685 2H6.5C5.673 2 5 2.673 5 3.5V4H3.5C2.673 4 2 4.673 2 5.5V12.927C2 13.324 2.2175 13.687 2.567 13.874C2.726 13.9595 2.9005 14 3.0745 14C3.322 14 3.49 13.941 3.6695 13.8215L5.651 12.5H10.9995V10.934L12.33 11.821C12.51 11.941 12.717 12.0015 12.925 12.0015C13.099 12.0015 13.273 11.959 13.4325 11.8735C13.7825 11.6865 13.9995 11.3235 13.9995 10.9265V6.2315C13.711 6.4905 13.3725 6.6935 12.9995 6.8255L13 10.927ZM5.3485 11.5L3.115 12.9895C3.069 13.016 3 12.9925 3 12.9275V5.5C3 5.2245 3.2245 5 3.5 5H5V10.5H10V11.5H5.3485Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_4765_880">
        <rect width="12" height="12" fill="white" transform="translate(2 2)" />
      </clipPath>
    </defs>
  </svg>
);
